import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class BarcodeParsing_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public BarcodeParsing: BarcodeParsing_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

